var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white",
    fillOpacity: 0.996078
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2073 39.2076L39.2073 43.2076C39.0197 43.3952 38.7652 43.5006 38.4998 43.5006C38.2344 43.5006 37.9799 43.3952 37.7923 43.2076C37.6047 43.0199 37.4993 42.7654 37.4993 42.5001C37.4993 42.2347 37.6047 41.9802 37.7923 41.7926L40.0861 39.5001H22.4998C22.2346 39.5001 21.9802 39.3947 21.7927 39.2072C21.6052 39.0196 21.4998 38.7653 21.4998 38.5001C21.4998 38.2349 21.6052 37.9805 21.7927 37.793C21.9802 37.6054 22.2346 37.5001 22.4998 37.5001H40.0861L37.7923 35.2076C37.6047 35.0199 37.4993 34.7654 37.4993 34.5001C37.4993 34.2347 37.6047 33.9802 37.7923 33.7926C37.9799 33.6049 38.2344 33.4995 38.4998 33.4995C38.7652 33.4995 39.0197 33.6049 39.2073 33.7926L43.2073 37.7926C43.3003 37.8854 43.374 37.9957 43.4244 38.1171C43.4747 38.2385 43.5006 38.3687 43.5006 38.5001C43.5006 38.6315 43.4747 38.7616 43.4244 38.883C43.374 39.0044 43.3003 39.1147 43.2073 39.2076ZM25.7923 31.2076C25.98 31.3952 26.2344 31.5006 26.4998 31.5006C26.7652 31.5006 27.0197 31.3952 27.2073 31.2076C27.395 31.0199 27.5004 30.7654 27.5004 30.5001C27.5004 30.2347 27.395 29.9802 27.2073 29.7926L24.9136 27.5001H42.4998C42.765 27.5001 43.0194 27.3947 43.2069 27.2072C43.3945 27.0196 43.4998 26.7653 43.4998 26.5001C43.4998 26.2349 43.3945 25.9805 43.2069 25.793C43.0194 25.6054 42.765 25.5001 42.4998 25.5001H24.9136L27.2073 23.2076C27.395 23.0199 27.5004 22.7654 27.5004 22.5001C27.5004 22.2347 27.395 21.9802 27.2073 21.7926C27.0197 21.6049 26.7652 21.4995 26.4998 21.4995C26.2344 21.4995 25.98 21.6049 25.7923 21.7926L21.7923 25.7926C21.6993 25.8854 21.6256 25.9957 21.5753 26.1171C21.5249 26.2385 21.499 26.3687 21.499 26.5001C21.499 26.6315 21.5249 26.7616 21.5753 26.883C21.6256 27.0044 21.6993 27.1147 21.7923 27.2076L25.7923 31.2076Z",
    fill: "#4F772D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#4F772D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferActive);
export default __webpack_public_path__ + "static/media/TransferActive.d1f0ea55e2d186dfaf90a35f26de8d66.svg";
export { ForwardRef as ReactComponent };